import React from "react";
import { Alert } from "@mui/material";
import { useRequest } from "hooks/useRequest";

export default function FirmwareBundleProgress({ serial }: { serial: string }): JSX.Element | null {
  const { data } = useRequest(`pendingActionsUIHook?serialNumber=${encodeURIComponent(serial)}&bundleStatus=true`, {
    refreshInterval: (current: any) =>
      current && ["queued", "device", "waiting_modem", "modem", "confirming", "failing"].includes(current.stage)
        ? 5000
        : 0,
  });
  if (
    !data ||
    Array.isArray(data) ||
    !["queued", "device", "waiting_modem", "modem", "confirming", "failing", "failed"].includes(data.stage)
  ) {
    return null;
  }
  return (
    <Alert severity={["failed", "failing"].includes(data.stage) ? "error" : "info"} sx={{ mt: 2 }}>
      {data.message}
    </Alert>
  );
}
